import { render, staticRenderFns } from "./viewdatail.vue?vue&type=template&id=4d0a7040&scoped=true&"
import script from "./viewdatail.vue?vue&type=script&lang=js&"
export * from "./viewdatail.vue?vue&type=script&lang=js&"
import style0 from "./viewdatail.vue?vue&type=style&index=0&id=4d0a7040&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0a7040",
  null
  
)

export default component.exports